import { useEffect, useState } from "react";
import { mh } from "@/lib/mh";
import { Eyebrow } from "@/components/mh/bits";
import { DeptCard } from "@/components/mh/DeptCard";

export default function Departments() {
  const [deps, setDeps] = useState([]);
  useEffect(() => { mh.departments().then((r) => setDeps(r.data)).catch(() => {}); }, []);
  return (
    <div className="max-w-[1500px] mx-auto space-y-8" data-testid="departments-page">
      <header className="mh-rise">
        <Eyebrow>The seven</Eyebrow>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-3">Departments, <em className="text-muted-foreground">mapped.</em></h1>
        <p className="text-sm sm:text-base text-muted-foreground mt-3 max-w-2xl">Each department has a rollout matrix, its own command centers, a live flow of every task and an autonomy cap you control.</p>
      </header>
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {deps.map((d, i) => <DeptCard key={d.slug} d={d} i={i} />)}
      </div>
    </div>
  );
}
